import TYPES from '@/modules/shared/types';

// Domain
import { InvestmentProductRepository } from '../../domain/repository';
import { AvailabilityToHireProductEntity } from '../../domain/entities/availability-to-hire-product-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class InvestmentProductHttpRepository implements InvestmentProductRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/investment/hire-product/`;

  findAvailabilityToHireProduct(investment_product_id: string): Promise<
    AvailabilityToHireProductEntity> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(`${this.endpoint}${investment_product_id}/validate-availability/`)
        .then((response) => {
          response.json()
            .then(({ data, success, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
